import React, { useCallback, useMemo } from 'react';
import {
  PinInput as ChakraPinInput,
  PinInputProps,
  PinInputField,
  useStyleConfig,
} from '@chakra-ui/react';

interface Props extends Omit<PinInputProps, `children`> {
  length?: number;
}

export const PinInput = (props: Props): JSX.Element => {
  const styles = useStyleConfig(`PinInput`, props);

  const array = useMemo(
    () => new Array(props.length || 4).fill(0),
    [props.length]
  );

  const renderPinInputField = useCallback(
    () =>
      array.map((_, key) => (
        <PinInputField
          key={key}
          borderWidth="2px"
          __css={styles}
          type="number"
          autoFocus={key === 0}
        />
      )),
    [array]
  );

  return <ChakraPinInput {...props}>{renderPinInputField()}</ChakraPinInput>;
};
export type { Props as PinInputProps };
